function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import PropTypes from "prop-types";
import useTheme from "./useTheme";
import useBreakpoint from "./useBreakpoint";
import defaultTheme from "../themes/default";
import { DEFAULT_BREAKPOINT } from "../utils/css";
import { hasOwnProperty } from "../utils/core";
export function getPropName(name, breakpoint) {
  return "".concat(name, "-").concat(breakpoint);
}
export function responsivePropType(propName, propType) {
  var result = _defineProperty({}, propName, propType);
  /*
    Note: 
    Here, as opposed to useResponsiveProp, we use defaultTheme.breakpoints, not theme.breakpoints.
    Ideally, we want to use theme.breakpoints, but the theme is not accessible when
    responsivePropType is called.
  */

  for (var bp in defaultTheme.breakpoints) {
    var prop = getPropName(propName, bp);
    result[prop] = propType;
  }
  return result;
}
export var responsiveMarginType = responsivePropType("margin", PropTypes.oneOfType([PropTypes.number, PropTypes.string]));
export var responsivePaddingType = responsivePropType("padding", PropTypes.oneOfType([PropTypes.number, PropTypes.string]));
var SIZE_PX_REGEX = /^\s*(\d+)(px)?\s*$/;
var responsiveSizeType = function responsiveSizeType(prop) {
  return responsivePropType(prop, function (props, propName, componentName) {
    var _match$;
    if (!hasOwnProperty(props, propName)) {
      return;
    }
    if (typeof props[propName] !== "string") {
      return new Error("".concat(componentName, ": ").concat(propName, " is expected to be a string. Found: ").concat(_typeof(props[propName]), "."));
    }
    if (props[propName].trim() === "") {
      return new Error("".concat(componentName, ": ").concat(propName, " can't be empty."));
    }
    if (props[propName].trim()[0] === "-") {
      return new Error("".concat(componentName, ": ").concat(propName, " can't be negative."));
    }
    var match = props[propName].match(SIZE_PX_REGEX);
    if (match === null) {
      return;
    }
    var intValue = parseInt(match[1], 10);
    var px = (_match$ = match[2]) !== null && _match$ !== void 0 ? _match$ : "";
    if (intValue % 4 !== 0) {
      var n = Math.floor(intValue / 4);
      return new Error("".concat(componentName, ": ").concat(propName, "=\"").concat(props[propName], "\". Please use a multiple of 4").concat(px, " (e.g. \"").concat(n * 4).concat(px, "\" or \"").concat((n + 1) * 4).concat(px, "\")."));
    }
  });
};
export var responsiveWidthType = responsiveSizeType("width");
export var responsiveHeightType = responsiveSizeType("height");
export var responsiveMaxWidthType = responsiveSizeType("maxWidth");
export var responsiveMaxHeightType = responsiveSizeType("maxHeight");
function useResponsiveProp(props, propName) {
  var theme = useTheme();
  var breakpoint = useBreakpoint();
  var result = props[propName] || null;
  if (breakpoint === null || breakpoint === DEFAULT_BREAKPOINT) {
    return result;
  }
  var breakpoints = Object.keys(theme.breakpoints);
  for (var i = 0, len = breakpoints.length; i < len; i++) {
    var bp = breakpoints[i];
    var prop = getPropName(propName, bp);
    if (hasOwnProperty(props, prop)) {
      result = props[prop];
    }
    if (bp === breakpoint) {
      break;
    }
  }
  return result;
}
export default useResponsiveProp;